import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import EditIcon from "@mui/icons-material/Edit";
import { DeleteIcon } from "../../../../components/icons/DeleteIcon";
import MapIcon from "../../../icons/MapIcon";
import UpdateDirection from "../../../../containers/Directions/UpdateDirection";
import DirectionsContext from "../../../../Context/Directions/DirectionsContext";

export const Card = ({ order, index, onCollapse, active }) => {
  const {
    country,
    name,
    postal_code,
    reference,
    zone,
    city,
    municipality,
    state,
    is_default,
    number_int,
    number_out,
    between_street,
    and_between_street,
    phone,
    email,
    id,
  } = order;

  const { setIsDefaultDirection, DeleteDirection } =
    useContext(DirectionsContext);

  const [openUpdate, setOpenUpdate] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpenUpdate = () => setOpenUpdate(true);
  const handleCloseUpdate = () => setOpenUpdate(false);

  const address = `${name}, ${country}, ${state.name}, ${
    municipality.name
  }, ${city}, 
    ${between_street}, ${and_between_street}, N° int: ${number_int ?? "N/A"}, 
    N° Ext: ${number_out ?? "N/A"}, ${zone}, ${postal_code}, ${reference}, 
    ${phone ?? "N/A"}, ${email ?? "N/A"}`;

  return (
    <>
      <Paper
        elevation={active === index ? 6 : 2}
        sx={{
          width: "100%",
          padding: 3,
          borderRadius: 3,
          border: "2px solid",
          borderColor: active === index ? "primary.main" : "grey.300",
          backgroundColor:
            active === index ? "primary.light" : "background.paper",
          transition: "all 0.3s ease-in-out",
          cursor: "pointer",
          ":hover": {
            boxShadow: 8,
            transform: "scale(1.01)",
          },
        }}
        onClick={() => onCollapse(index)}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems='flex-start'
        >
          <Box sx={{ mt: 0.5 }}>
            <MapIcon fontSize='large' />
          </Box>

          <Box flex={1}>
            <Typography
              variant='subtitle2'
              color='text.secondary'
              fontWeight='bold'
              gutterBottom
            >
              Dirección de entrega
            </Typography>
            <Typography variant='body1' sx={{ whiteSpace: "pre-wrap" }}>
              {address}
            </Typography>
          </Box>

          <Stack direction='row' spacing={1}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                if (!is_default) setIsDefaultDirection(id);
              }}
              title={
                is_default ? "Dirección por defecto" : "Marcar como por defecto"
              }
            >
              <StarIcon sx={{ color: is_default ? "gold" : "gray" }} />
            </IconButton>

            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleOpenUpdate();
              }}
              title='Editar dirección'
            >
              <EditIcon sx={{ color: "#801F56" }} />
            </IconButton>

            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                DeleteDirection(id);
              }}
              title='Eliminar dirección'
            >
              <DeleteIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Paper>

      {openUpdate && (
        <UpdateDirection
          open={openUpdate}
          id={id}
          handleClose={handleCloseUpdate}
        />
      )}
    </>
  );
};
